import React, { useState } from 'react'
import { CardsOverview } from './CardsOverview'
import { CardsFixtureDetail } from './CardsFixtureDetail'
import { CardsSavedFixtures } from './CardsSavedFixtures'
import { useFeatureTracking, FeatureNames } from '../../hooks/useActivityTracking'

export type CardsHubView = 'overview' | 'fixture' | 'saved'

interface CardsHubProps {
  initialView?: CardsHubView
  initialFixtureId?: number | null
}

export function CardsHub({ initialView = 'overview', initialFixtureId = null }: CardsHubProps) {
  // Track feature usage
  useFeatureTracking(FeatureNames.CARDS_HUB)
  const [view, setView] = useState<CardsHubView>(initialView)
  const [selectedFixtureId, setSelectedFixtureId] = useState<number | null>(initialFixtureId)
  const [selectedDate, setSelectedDate] = useState<string | null>(null)

  const handleFixtureSelect = (fixtureId: number) => {
    setSelectedFixtureId(fixtureId)
    setView('fixture')
  }

  const handleBackToOverview = () => {
    setSelectedFixtureId(null)
    setView('overview')
  }

  const handleViewSaved = () => {
    setView('saved')
  }

  const handleDateChange = (date: string) => {
    setSelectedDate(date)
    setView('overview')
  }

  return (
    <div className="cards-hub">
      {view === 'overview' && (
        <CardsOverview
          date={selectedDate}
          onDateChange={handleDateChange}
          onFixtureSelect={handleFixtureSelect}
          onViewSaved={handleViewSaved}
        />
      )}
      {view === 'fixture' && selectedFixtureId && (
        <CardsFixtureDetail
          fixtureId={selectedFixtureId}
          onBack={handleBackToOverview}
        />
      )}
      {view === 'saved' && (
        <CardsSavedFixtures
          onBack={handleBackToOverview}
          onFixtureSelect={handleFixtureSelect}
        />
      )}
    </div>
  )
}
